// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__27Wec","cell":"ColumnAccessor_cell__3LJrs","firstCellAccent":"ColumnAccessor_firstCellAccent__oIUwT"};